// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";

export const getIsReady = (state: ApplicationState) => {
    const { parameter } = state.pages.productList;

    return Boolean(parameter);
};

export const getIsBrandPage = (state: ApplicationState) => {
    const { filterQuery, parameter } = state.pages.productList;
    const brandId = parameter?.brandIds?.[0];

    return brandId ? !filterQuery?.includes(brandId) : false;
};

export const getIsCategoryPage = (state: ApplicationState) => {
    const { filterQuery, parameter } = state.pages.productList;
    const categoryId = parameter?.categoryId;

    return categoryId ? !filterQuery?.includes(categoryId) : false;
};

export const getIsSearchPage = (state: ApplicationState) => {
    return Boolean(getIsReady(state) && !getIsCategoryPage(state) && !getIsBrandPage(state));
};

export const getSearchQuery = (state: ApplicationState) => {
    const { parameter } = state.pages.productList;
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");

    if (!getIsSearchPage(state)) {
        return null;
    }

    return parameter?.search ? correctedQuery || parameter?.search : undefined;
};

export const getIsFilterNavOpen = (state: ApplicationState) => {
    return state.starter.pages.productList.isFilterNavOpen;
};

export const getContentSearchParameter = (state: ApplicationState) => {
    return state.starter.pages.productList.getContentSearchApiParameter;
};

export const getContentSearchCurrentTab = (state: ApplicationState) => {
    const location = getLocation(state);
    const parsedQueryString: { currentTab: "" } = parseQueryString(location.search);
    // Need this to avoid returning an undefined currentTab and seeing the page blink when reloading the page in the "content" tab.
    return state.starter.pages.productList.getContentSearchApiParameter.currentTab || parsedQueryString.currentTab;
};
